// Pure SVG geometry. Financial buckets and their amounts are never modified.
export const buildFlowGeometry = (data, visibleSeries) => {
    const width = 720;
    const height = 184;
    const padding = { top: 14, right: 14, bottom: 28, left: 14 };
    const chartHeight = height - padding.top - padding.bottom;
    let maxValue = 1;
    let invalidValueCount = 0;
    for (const item of data) {
        for (const key of visibleSeries) {
            const value = item?.[key];
            if (!Number.isFinite(value) || value < 0) invalidValueCount += 1;
            else maxValue = Math.max(maxValue, value);
        }
    }
    let valid = invalidValueCount === 0;
    const getX = (index) => data.length <= 1 ? width / 2
        : padding.left + (index / (data.length - 1)) * (width - padding.left - padding.right);
    const getY = (value) => padding.top + chartHeight - (value / maxValue) * chartHeight;
    const paths = {};
    const series = {};
    if (valid && data.length) {
        for (const key of visibleSeries) {
            const points = data.map((item, index) => ({ x: getX(index), y: getY(item[key]) }));
            const coordinatesValid = points.every(point => Number.isFinite(point.x) && Number.isFinite(point.y));
            const domainValid = Number.isFinite(maxValue) && maxValue > 0 && width > 0 && chartHeight > 0;
            // One bucket is a marker, not an interpolated timeline. A move-only M
            // command has no stroke; use a small centered glyph without adding data.
            const path = points.length === 1
                ? `M ${points[0].x - 3} ${points[0].y} L ${points[0].x + 3} ${points[0].y}`
                : points.slice(1).reduce((path, point, index) => {
                const previous = points[index];
                const middleX = (previous.x + point.x) / 2;
                return `${path} C ${middleX} ${previous.y}, ${middleX} ${point.y}, ${point.x} ${point.y}`;
            }, `M ${points[0].x} ${points[0].y}`);
            const drawable = coordinatesValid && domainValid && Boolean(path) && !/NaN|Infinity/.test(path);
            series[key] = { valid: drawable, pointCount: points.length, points, path };
            if (drawable) paths[key] = path;
            else valid = false;
        }
    }
    if (!valid) Object.keys(paths).forEach(key => delete paths[key]);
    return { width, height, padding, chartHeight, valid, invalidValueCount, series,
        hasNaN: data.some(item => visibleSeries.some(key => Number.isNaN(item?.[key]))),
        pointCount: data.length, xDomain: [0, Math.max(0, data.length - 1)],
        yDomain: [0, maxValue], paths, getX, getY };
};
